import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useUIContext from '../ui/use-ui-context';

export const useScrollToTopCallback = () => {
	const { scrollbar } = useUIContext();
	const callback = useCallback(() => {
		if (scrollbar?.current?.scrollToTop) {
			scrollbar.current.scrollToTop();
		} else {
			window.scrollTo(0, 0);
		}
	}, [scrollbar]);
	return callback;
};

/**
 * Scrolls to top on mount and every time path changes
 */
const useScrollToTop = () => {
	const { pathname } = useLocation();
	const scrollToTop = useScrollToTopCallback();

	useEffect(() => {
		scrollToTop();
	}, [pathname, scrollToTop]);
};

/**
 * Scrolls to top once on mount
 */
export const useScrollToTopOnce = () => {
	const scrollToTop = useScrollToTopCallback();

	useEffect(() => {
		scrollToTop();
	}, [scrollToTop]);
};

export default useScrollToTop;
